import {
  CREATE_DISCIPLINE,
  UPDATE_DISCIPLINE,
  GET_DISCIPLINE_HISTORY,
  DELETE_DISCIPLINE_HISTORY,
} from "./types";
import { DisciplineType, UpdateDisciplineType } from "@type/HRM/discipline";

export const createDisciplineRequest = (data: DisciplineType) => {
  return {
    type: CREATE_DISCIPLINE.CREATE_DISCIPLINE_REQUEST,
    payload: {
      data,
    },
  } as const;
};

export const createDisciplineSuccess = (data: DisciplineType) => {
  return {
    type: CREATE_DISCIPLINE.CREATE_DISCIPLINE_SUCCESS,
    payload: {
      data,
    },
  } as const;
};

export const createDisciplineFailed = () => {
  return {
    type: CREATE_DISCIPLINE.CREATE_DISCIPLINE_FAILED,
  } as const;
};

export const updateDisciplineRequest = (data: UpdateDisciplineType) => {
  return {
    type: UPDATE_DISCIPLINE.UPDATE_DISCIPLINE_REQUEST,
    payload: {
      data,
    },
  } as const;
};

export const updateDisciplineSuccess = (data: UpdateDisciplineType) => {
  return {
    type: UPDATE_DISCIPLINE.UPDATE_DISCIPLINE_SUCCESS,
    payload: {
      data,
    },
  } as const;
};

export const updateDisciplineFailed = () => {
  return {
    type: UPDATE_DISCIPLINE.UPDATE_DISCIPLINE_FAILED,
  } as const;
};

export const getDisciplineRequest = (data: number | null) => {
  return {
    type: GET_DISCIPLINE_HISTORY.GET_DISCIPLINE_HISTORY_REQUEST,
    payload: { data },
  } as const;
};

export const getDisciplineSuccess = (data: DisciplineType) =>
  ({
    type: GET_DISCIPLINE_HISTORY.GET_DISCIPLINE_HISTORY_SUCCESS,
    payload: { data },
  } as const);

export const getDisciplineFailed = () =>
  ({
    type: GET_DISCIPLINE_HISTORY.GET_DISCIPLINE_HISTORY_FAILED,
  } as const);

export const deleteDisciplineRequest = (data: {
  disciplineID: number;
  employeeID: number | null;
}) => {
  return {
    type: DELETE_DISCIPLINE_HISTORY.DELETE_DISCIPLINE_TABLE_REQUEST,
    payload: { data },
  } as const;
};

export const deleteDisciplineSuccess = (data: { id: number }) => {
  return {
    type: DELETE_DISCIPLINE_HISTORY.DELETE_DISCIPLINE_TABLE_SUCCESS,
    payload: {
      data,
    },
  } as const;
};

export const deleteDisciplineFailed = () => {
  return {
    type: DELETE_DISCIPLINE_HISTORY.DELETE_DISCIPLINE_TABLE_FAILED,
  } as const;
};

export type DisciplineActions =
  | ReturnType<typeof createDisciplineRequest>
  | ReturnType<typeof createDisciplineSuccess>
  | ReturnType<typeof createDisciplineFailed>
  | ReturnType<typeof updateDisciplineRequest>
  | ReturnType<typeof updateDisciplineSuccess>
  | ReturnType<typeof updateDisciplineFailed>
  | ReturnType<typeof getDisciplineRequest>
  | ReturnType<typeof getDisciplineSuccess>
  | ReturnType<typeof getDisciplineFailed>
  | ReturnType<typeof deleteDisciplineRequest>
  | ReturnType<typeof deleteDisciplineSuccess>
  | ReturnType<typeof deleteDisciplineFailed>;
